import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import styles from "./styles/Billing.module.css";
import TableFilter from "./TableFilter";
import { BillingTable } from "./BillingTable";
import TableFooter from "./TableFooter";
import { formatDate } from "../../../Utils/formatDate";
import config from "../../../config";

const base_url = config.base_url;
function Billing() {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    filter_value: "",
    filter_field: "user_id",
    max_date: Date.now(),
    min_date: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 7
    ).getTime(),
    sort: "",
    nlogs: "20",
    page: 1,
  });
  const [maxPages, setmaxPages] = useState(1);
  const RequestData = (filter) => {
    fetch(base_url + "admin/billing", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `filter_value=${filter.filter_value}&filter_field=${filter.filter_field}&max_date=${filter.max_date}&min_date=${filter.min_date}&nlogs=${filter.nlogs}&page=${filter.page}&sort=${filter.sort}`,
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) alert("");
        else {
          if (data.result.total === 0) setmaxPages(1);
          else setmaxPages(Math.ceil(data.result.total / filter.nlogs));
          setData(data.result.data);
        }
      });
  };
  const DownloadCSV = (filter) => {
    fetch(base_url + "admin/billing/download", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `filter_value=${filter.filter_value}&max_date=${filter.max_date}&min_date=${filter.min_date}`,
      credentials: "include",
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "EventLogs.csv");
        document.body.appendChild(link);
        link.click();
      });
  };
  useEffect(() => {
    console.log(filter);
    RequestData(filter);
  }, [filter]);
  useEffect(() => {
    handleChange(1, "page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPages]);
  const columns = useMemo(
    () => [
      {
        Header: "User ID",
        accessor: "user_id",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "First Name",
        accessor: "first_name",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Type",
        accessor: "type",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Plan",
        accessor: "plan",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "Last Login",
        accessor: "last_login",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value !== "UNKNOWN" ? formatDate(value) : value}</span>;
        },
      },
      {
        Header: "Inheritance Mechanism Status",
        accessor: "inheritance_status",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          return <span>{value}</span>;
        },
      },
    ],
    []
  );
  const handleChange = (value, field) => {
    console.log(`${value},${field}`);
    setFilter({ ...filter, [field]: value });
  };

  return (
    <div className={styles.main_box}>
      <h1>Billing</h1>
      {/* <h2 className={styles.sub_title}>What are assets</h2> */}
      <div className={styles.table_div}>
        <TableFilter
          filter={filter}
          setFilter={setFilter}
          handleChange={handleChange}
          DownloadCSV={DownloadCSV}
          displayCalendar={false}
        />
        <BillingTable
          columns={columns}
          data={data}
          filter={filter}
          setFilter={setFilter}
          handleChange={handleChange}
        />
        <TableFooter
          filter={filter}
          setFilter={setFilter}
          maxPages={maxPages}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
}

export default Billing;
